import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import { isSSR } from "../plugins/Platform.js";
var ssrAPI = {
  onOk: function onOk() {
    return ssrAPI;
  },
  okCancel: function okCancel() {
    return ssrAPI;
  },
  hide: function hide() {
    return ssrAPI;
  },
  update: function update() {
    return ssrAPI;
  }
};
export function merge(target, source) {
  for (var key in source) {
    if (key !== 'spinner' && Object(source[key]) === source[key]) {
      target[key] = Object(target[key]) !== target[key] ? {} : _objectSpread({}, target[key]);
      merge(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
}
export default function (DefaultComponent) {
  return function (_ref) {
    var className = _ref.className,
        klass = _ref.class,
        style = _ref.style,
        component = _ref.component,
        root = _ref.root,
        parent = _ref.parent,
        props = _objectWithoutProperties(_ref, ["className", "class", "style", "component", "root", "parent"]);

    if (isSSR === true) {
      return ssrAPI;
    }

    klass !== void 0 && (props.cardClass = klass);
    style !== void 0 && (props.cardStyle = style);
    var isCustom = component !== void 0;
    var DialogComponent, attrs;

    if (isCustom === true) {
      DialogComponent = component;
    } else {
      DialogComponent = DefaultComponent;
      attrs = props;
    }

    var okFns = [],
        cancelFns = [],
        API = {
      onOk: function onOk(fn) {
        okFns.push(fn);
        return API;
      },
      onCancel: function onCancel(fn) {
        cancelFns.push(fn);
        return API;
      },
      onDismiss: function onDismiss(fn) {
        okFns.push(fn);
        cancelFns.push(fn);
        return API;
      },
      hide: function hide() {
        vm.$refs.dialog.hide();
        return API;
      },
      update: function update(_ref2) {
        var className = _ref2.className,
            klass = _ref2.class,
            style = _ref2.style,
            component = _ref2.component,
            root = _ref2.root,
            parent = _ref2.parent,
            cfg = _objectWithoutProperties(_ref2, ["className", "class", "style", "component", "root", "parent"]);

        if (vm !== null) {
          klass !== void 0 && (cfg.cardClass = klass);
          style !== void 0 && (cfg.cardStyle = style);

          if (isCustom === true) {
            Object.assign(props, cfg);
          } else {
            merge(props, cfg); // need to change "attrs" reference to
            // actually reflect it in underlying component
            // when we force update it

            attrs = _objectSpread({}, props);
          }

          vm.$forceUpdate();
        }

        return API;
      }
    };
    var node = document.createElement('div');
    document.body.appendChild(node);
    var emittedOK = false;
    var on = {
      ok: function ok(data) {
        emittedOK = true;
        okFns.forEach(function (fn) {
          fn(data);
        });
      },
      hide: function hide() {
        vm.$destroy();
        vm.$el.remove();
        vm = null;

        if (emittedOK !== true) {
          cancelFns.forEach(function (fn) {
            fn();
          });
        }
      }
    };
    var vm = new Vue({
      name: 'QGlobalDialog',
      el: node,
      parent: parent === void 0 ? root : parent,
      render: function render(h) {
        return h(DialogComponent, {
          ref: 'dialog',
          props: props,
          attrs: attrs,
          on: on
        });
      },
      mounted: function mounted() {
        var _this = this;

        if (this.$refs.dialog !== void 0) {
          this.$refs.dialog.show();
        } else {
          on['hook:mounted'] = function () {
            _this.$refs.dialog !== void 0 && _this.$refs.dialog.show();
          };
        }
      }
    });
    return API;
  };
}